import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import AcceptAllModal from "./AcceptAllModal";
import UploadImageModal from "./UploadImageModal";
import DeclinedReasonPopup from "./DeclinedReasonPopup";
import dayjs from "dayjs";
import { ChevronDown } from "lucide-react";
import { DateRange } from 'react-date-range';
import { FiMoreHorizontal, FiArrowRight, FiArrowLeft } from "react-icons/fi";
import { FaFilter, FaBars } from "react-icons/fa";
import { PDFDocument } from "pdf-lib";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Bluedart from "../../../assets/bluedart.png";
import Delehivery from "../../../assets/delehivery.png";
import EcomExpress from "../../../assets/ecom-expresss.avif";
import Shadowfax from "../../../assets/shadowfax.png";
import Xpressbees from "../../../assets/xpressbees.png";
import Shiprocket from "../../../assets/shiprocket.webp";
import NimbusPost from "../../../assets/nimbuspost.webp";
import ShreeMaruti from "../../../assets/shreemaruti.png";
import DTDC from "../../../assets/dtdc.png";
import Amazon from "../../../assets/amazon.jpg";
import ThreeDotLoader from "../../../Loader"



const NewDiscrepancy = ({ refresh, setRefresh }) => {
    const [dropdownOpen, setDropdownOpen] = useState(null);
    const [orders, setOrders] = useState([]);
    const [refresh1, setRefresh1] = useState(false);
    const [loadingOrderId, setLoadingOrderId] = useState(null);
    const [selectedOrders, setSelectedOrders] = useState([]); // Track selected orders
    const [actionDropdownOpen, setActionDropdownOpen] = useState(false); // New dropdown state
    const [searchQuery, setSearchQuery] = useState("");
    const dropdownRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [ndrData, setNdrData] = useState([])
    const [price, setPrice] = useState(0);
    const [loading, setLoading] = useState(false); // New loading state
    const [isOpen, setIsOpen] = useState(false);
    const [declienedPopup, setDeclienedPopup] = useState(false);
    const [reason, setReason] = useState(null)
    const [limit, setLimit] = useState(20);
    const [totalPages, setTotalPages] = useState(0);
    const [awbNumber, setAwbNumber] = useState("");
    const [orderId, setOrderId] = useState("");
    const [page, setPage] = useState(1);
    const [provider, setProvider] = useState("");
    const [dateRange, setDateRange] = useState("");
    const [showCalendar, setShowCalendar] = useState(false);
    const [customDateLabel, setCustomDateLabel] = useState('');
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const calendarRef = useRef();
    const dateDropdownRef = useRef(null);
    const providerRef = useRef(null);
    const [showProviderDropdown, setShowProviderDropdown] = useState(false);
    const dropdownRefs = useRef([]);

    const toggleButtonRefs = useRef([]);

    const actionDropdownRef = useRef(null);
    const [customRange, setCustomRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]);
    const carrierLogos = {
        Bluedart,
        Delhivery: Delehivery,
        Ecom: EcomExpress,
        Shadowfax,
        Xpressbees,
        NimbusPost,
        Shiprocket,
        ShreeMaruti,
        DTDC,
        Amazon,
    };


    const handleApplyCustomDate = () => {
        setShowCalendar(false);
        const start = dayjs(customRange[0].startDate).format("MMM D");
        const end = dayjs(customRange[0].endDate).format("MMM D");

        setCustomDateLabel(`${start} - ${end}`);
        setDateRange("custom"); // Ensure it's always "custom"
        fetchDiscrepancy();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                providerRef.current &&
                dateDropdownRef.current &&
                !providerRef.current.contains(event.target) &&
                !dateDropdownRef.current.contains(event.target)
            ) {
                setShowProviderDropdown(false);
                setShowDateDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getDateRange = () => {
        const today = dayjs();
        switch (dateRange) {
            case "today":
                return {
                    fromDate: today.startOf("day").toISOString(),
                    toDate: today.endOf("day").toISOString(),
                };
            case "yesterday":
                return {
                    fromDate: today.subtract(1, "day").startOf("day").toISOString(),
                    toDate: today.subtract(1, "day").endOf("day").toISOString(),
                };
            case "last5days":
                return {
                    fromDate: today.subtract(5, "day").startOf("day").toISOString(),
                    toDate: today.endOf("day").toISOString(),
                };
            case "thisMonth":
                return {
                    fromDate: today.startOf("month").toISOString(),
                    toDate: today.endOf("month").toISOString(),
                };
            case "lastMonth":
                const lastMonth = today.subtract(1, "month");
                return {
                    fromDate: lastMonth.startOf("month").toISOString(),
                    toDate: lastMonth.endOf("month").toISOString(),
                };
            case "custom":
                return {
                    fromDate: customRange[0].startDate.toISOString(),
                    toDate: customRange[0].endDate.toISOString(),
                };
            default:
                return {};
        }
    };

    const handleExportExcel = () => {
        if (selectedOrders.length === 0) {
            toast.error("No orders selected for export.");
            return;
        }

        // Filter only selected orders
        const exportData = orders
            .filter(order => selectedOrders.includes(order._id))
            .map(order => ({
                "Order ID": order.orderId,
                "Order Status": order.status,
                "Order Date": new Date(order.createdAt).toLocaleString(),
                "Sender Name": order.pickupAddress?.contactName,
                "Sender Email": order.pickupAddress?.email,
                "Sender Phone": order.pickupAddress?.phoneNumber,
                "Sender Address": order.pickupAddress?.address,
                "Sender City": order.pickupAddress?.city,
                "Sender State": order.pickupAddress?.state,
                "Sender Pin": order.pickupAddress?.pinCode,
                "Receiver Name": order.receiverAddress?.contactName,
                "Receiver Email": order.receiverAddress?.email,
                "Receiver Phone": order.receiverAddress?.phoneNumber,
                "Receiver Address": order.receiverAddress?.address,
                "Receiver City": order.receiverAddress?.city,
                "Receiver State": order.receiverAddress?.state,
                "Receiver Pin": order.receiverAddress?.pinCode,
                "Payment Method": order.paymentDetails?.method,
                "Payment Amount": order.paymentDetails?.amount,
                "Courier": order.courierServiceName,
                "AWB Number": order.awb_number,
                // Add more fields as needed
                "Products": order.productDetails?.map(
                    p => `Name: ${p.name}, SKU: ${p.sku}, Qty: ${p.quantity}, Price: ${p.unitPrice}`
                ).join(" | ")
            }));

        // Create worksheet and workbook
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Orders");

        // Generate buffer and save
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, "orders.xlsx");
    };

    const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

    const navigate = useNavigate();
    const handleOpenPopup = (awb) => {
        setAwbNumber(awb);  // Store AWB number
        setIsOpen(true);
    };

    const handleDeclinedPopup = (awb, reason) => {
        setAwbNumber(awb);  // Store AWB number
        setReason(reason)
        setDeclienedPopup(true);
    }
    const toggleDropdown = (index) => {
        // Delay the toggle so it doesn't conflict with the mousedown event
        setTimeout(() => {
            setDropdownOpen((prev) => (prev === index ? null : index));
        }, 0);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            const clickedInsideAnyDropdown = dropdownRefs.current.some(
                (ref) => ref && ref.contains(event.target)
            );
            const clickedAnyToggleButton = toggleButtonRefs.current.some(
                (ref) => ref && ref.contains(event.target)
            );

            if (!clickedInsideAnyDropdown && !clickedAnyToggleButton) {
                setDropdownOpen(null);
            }
        };

        // ✅ Use 'click' instead of 'mousedown'
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                actionDropdownRef.current &&
                !actionDropdownRef.current.contains(event.target)
            ) {
                setActionDropdownOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);



    useEffect(() => {
        fetchDiscrepancy();
    }, [dateRange, page, limit, orderId, awbNumber, provider, refresh1]);

    const fetchDiscrepancy = async () => {
        try {
            const [_, token] = document.cookie.split("=");
            const { fromDate, toDate } = getDateRange();
            setLoading(true)
            const response = await axios.get(
                `${REACT_APP_BACKEND_URL}/dispreancy/allDispreancyById`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                    params: {
                        fromDate,
                        toDate,
                        page,
                        limit,
                        orderId,
                        awbNumber,
                        provider,
                        status: "new"
                    },
                }
            );
            console.log("trans", response.data.results)
            setOrders(response.data.results || []);
            setTotalPages(response.data.page || 0);
            setLoading(false)
        } catch (error) {
            toast.error("Error fetching transactions");
        }
    };



    const handleSelectAll = () => {
        if (selectedOrders.length === orders.length) {
            setSelectedOrders([]); // Unselect all
            setPrice(0); // Reset price
        } else {
            const allOrderIds = orders.map(order => order._id);
            const totalPrice = orders
                .map(order => parseFloat(order.excessWeightCharges.pendingAmount)) // Convert to number
                .reduce((a, b) => a + b, 0); // Sum up all amounts

            setSelectedOrders(allOrderIds);
            setPrice(parseFloat(totalPrice.toFixed(2))); // Ensure correct rounding
        }
    };


    // Handle individual row selection
    const handleCheckboxChange = (orderId) => {
        setSelectedOrders((prevSelectedOrders) => {
            let updatedSelectedOrders = [...prevSelectedOrders];
            let updatedPrice = price;

            const selectedOrder = orders.find(order => order._id === orderId);
            if (!selectedOrder) {
                console.error(`Order with ID ${orderId} not found`);
                return prevSelectedOrders;
            }

            const pendingAmount = parseFloat(selectedOrder.excessWeightCharges.pendingAmount);

            if (prevSelectedOrders.includes(orderId)) {
                // Deselecting: Remove order and subtract its price
                updatedSelectedOrders = prevSelectedOrders.filter(id => id !== orderId);
                updatedPrice -= pendingAmount;
            } else {
                // Selecting: Add order and add its price
                updatedSelectedOrders.push(orderId);
                updatedPrice += pendingAmount;
            }
            console.log("Selected Orders:", updatedSelectedOrders);
            console.log("Updated Price:", updatedPrice);
            setPrice(parseFloat(updatedPrice.toFixed(2))); // Ensure it's correctly rounded
            return updatedSelectedOrders;
        });
    };




    const handleDiscrepancy = async (awb_number) => {
        setLoading(true);
        try {
            const [session, token] = document.cookie.split("=");
            const payload = {
                awb_number: awb_number
            }
            const response = await axios.post(
                `${REACT_APP_BACKEND_URL}/dispreancy/acceptDiscrepancy`, payload,
                {
                    headers: {
                        authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log(response.data)
            toast.success(response.data.message)
            setRefresh1(true)
            setRefresh(true)



            // console.log(orders)
        } catch (error) {
            toast.error(error.response.data.message)
            console.error("Error fetching orders:", error);
        } finally {
            setLoading(false);
        }
    }
    const handleTrackingByAwb = (awb) => {
        navigate(`/dashboard/order/tracking/${awb}`);
    };
    const handleClearFilters = () => {
        setAwbNumber("");
        setDateRange([{ startDate: null, endDate: null, key: "selection" }]);
        setProvider("")
    }



    return (
        <div>
            {/* Desktop Table */}
            <div className="flex w-full flex-col sm:flex row gap-1 mb-2">
                <div className="flex gap-2">
                    <div className="flex gap-2 w-full">
                        <input
                            type="text"
                            placeholder="Search by AWB Number"
                            className="w-full md:w-[200px] h-9 px-3 text-[12px] font-[600] border-2 rounded-lg focus:outline-none placeholder:text-[12px]"
                            onChange={(e) => setAwbNumber(e.target.value)}
                            value={awbNumber}
                        />

                        {/* Date Range Dropdown */}
                        <div className="relative sm:flex hidden" ref={dateDropdownRef}>
                            <button
                                onClick={() => setShowDateDropdown((prev) => !prev)}
                                className="sm:w-[100px] text-gray-500 h-9 px-3 py-2 border rounded-lg text-left sm:text-[12px] font-[600] text-[12px] bg-white flex items-center justify-between"
                                type="button"
                            >
                                {customDateLabel || "Dates"}
                                <ChevronDown className={`w-4 h-4 transform transition-transform ${showDateDropdown ? "rotate-180" : ""}`} />
                            </button>

                            {showDateDropdown && (
                                <ul className="absolute z-30 w-full mt-10 bg-white border rounded-lg max-h-60 overflow-y-auto text-[12px] font-[600] text-gray-500">
                                    {[
                                        // { value: "", label: "Dates" },
                                        { value: "today", label: "Today" },
                                        { value: "yesterday", label: "Yesterday" },
                                        { value: "last5days", label: "Last 5 Days" },
                                        { value: "thisMonth", label: "This Month" },
                                        { value: "lastMonth", label: "Last Month" },
                                        { value: "custom", label: customDateLabel ? `Custom: ${customDateLabel}` : "Custom" }
                                    ].map((item) => (
                                        <li
                                            key={item.value || "default"}
                                            className={`px-3 py-2 cursor-pointer hover:bg-green-100 ${dateRange === item.value ? "bg-green-100 font-[600]" : ""}`}
                                            onClick={() => {
                                                setDateRange(item.value);
                                                setShowDateDropdown(false);
                                                if (item.value === "custom") {
                                                    setShowCalendar(true);
                                                } else {
                                                    setShowCalendar(false);
                                                }
                                            }}
                                        >
                                            {item.label}
                                        </li>
                                    ))}
                                </ul>
                            )}

                            {/* Calendar Dropdown */}
                            {showCalendar && (
                                <div
                                    ref={calendarRef}
                                    className="absolute z-30 mt-2 bg-white rounded-lg p-2 w-[350px]"
                                >
                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={(item) => setCustomRange([item.selection])}
                                        moveRangeOnFirstSelection={false}
                                        ranges={customRange}
                                        maxDate={new Date()}
                                        showDateDisplay={false}
                                    />
                                    <button
                                        onClick={handleApplyCustomDate}
                                        className="w-full mt-2 bg-[#0CBB7D] text-white text-sm py-1 px-3 rounded hover:bg-green-600"
                                    >
                                        Apply
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Provider Filter */}
                        <div className="relative sm:flex hidden" ref={providerRef}>
                            <button
                                onClick={() => setShowProviderDropdown((prev) => !prev)}
                                className="sm:w-[100px] text-gray-500 h-9 px-3 py-2 border-2 rounded-lg text-left text-[12px] bg-white flex justify-between items-center font-[600]"
                                type="button"
                            >
                                <span>{provider || "Provider"}</span>
                                <ChevronDown
                                    className={`w-4 h-4 transition-transform duration-200 ${showProviderDropdown ? "rotate-180" : ""}`}
                                />
                            </button>
                            {showProviderDropdown && (
                                <ul className="absolute z-40 w-full mt-10 bg-white border rounded-lg max-h-60 overflow-y-auto text-[12px] font-[600] text-gray-500">
                                    {["Delhivery", "DTDC", "EcomExpress", "Amazon"].map((s) => (
                                        <li
                                            key={s || "empty"}
                                            className={`px-3 py-2 cursor-pointer hover:bg-green-100 ${provider === s ? "bg-green-100 font-[600]" : ""
                                                }`}
                                            onClick={() => {
                                                setProvider(s);
                                                setShowProviderDropdown(false);
                                            }}
                                        >
                                            {s || "Provider"}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    <div className="flex sm:w-[90px] gap-1">
                        {/* Bulk Action Dropdown */}
                        <div ref={actionDropdownRef}>
                            <button
                                className={`px-3 sm:w-[90px] h-9 border-2 rounded-lg font-[600] flex items-center gap-1 ${selectedOrders.length === 0
                                    ? "border-gray-200 text-[10px] sm:text-[12px] cursor-not-allowed text-gray-400"
                                    : "text-[#0CBB7D] border-[#0CBB7D] text-[10px] sm:text-[12px]"
                                    }`}
                                onClick={() =>
                                    selectedOrders.length > 0 &&
                                    setActionDropdownOpen(!actionDropdownOpen)
                                }
                                disabled={selectedOrders.length === 0}
                            >
                                <FaBars
                                    className={`sm:hidden 
                          ${selectedOrders.length === 0 ? "text-gray-400" : "text-[#0CBB7D]"}`}
                                />
                                <span className="hidden sm:inline">Actions ▼</span>
                            </button>

                            {actionDropdownOpen && (
                                <div className="absolute right-6 mt-2 w-20 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                                    <ul className="font-[600]">
                                        <li
                                            className="px-3 py-2 text-gray-700 hover:bg-green-100 rounded-lg cursor-pointer text-[10px]"
                                            onClick={handleExportExcel}
                                        >
                                            Export
                                        </li>
                                        <li
                                            className="px-3 py-2 text-gray-700 cursor-pointer rounded-lg text-[10px] hover:bg-green-100"
                                            onClick={() => setIsModalOpen(true)}
                                        >
                                            Accept
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                    <button
                        className="px-3 hidden items-center sm:flex h-9 text-[10px] sm:text-[12px] border-2 rounded-lg font-[600] text-white bg-[#0CBB7D] hover:bg-green-500 transition"
                        onClick={handleClearFilters}
                        type="button"
                    >
                        Clear
                    </button>
                </div>

                <div className="flex gap-2 sm:hidden">
                    {/* Date Range Dropdown */}
                    <div className="relative flex w-full" ref={dateDropdownRef}>
                        <button
                            onClick={() => setShowDateDropdown((prev) => !prev)}
                            className="sm:w-[100px] w-full text-gray-500 h-9 px-3 py-2 border rounded-lg text-left sm:text-[12px] font-[600] text-[12px] bg-white flex items-center justify-between"
                            type="button"
                        >
                            {customDateLabel || "Dates"}
                            <ChevronDown className={`w-4 h-4 transform transition-transform ${showDateDropdown ? "rotate-180" : ""}`} />
                        </button>

                        {showDateDropdown && (
                            <ul className="absolute z-30 w-full mt-10 bg-white border rounded-lg max-h-60 overflow-y-auto text-[12px] font-[600] text-gray-500">
                                {[
                                    // { value: "", label: "Dates" },
                                    { value: "today", label: "Today" },
                                    { value: "yesterday", label: "Yesterday" },
                                    { value: "last5days", label: "Last 5 Days" },
                                    { value: "thisMonth", label: "This Month" },
                                    { value: "lastMonth", label: "Last Month" },
                                    { value: "custom", label: customDateLabel ? `Custom: ${customDateLabel}` : "Custom" }
                                ].map((item) => (
                                    <li
                                        key={item.value || "default"}
                                        className={`px-3 py-2 cursor-pointer hover:bg-green-100 ${dateRange === item.value ? "bg-green-100 font-[600]" : ""}`}
                                        onClick={() => {
                                            setDateRange(item.value);
                                            setShowDateDropdown(false);
                                            if (item.value === "custom") {
                                                setShowCalendar(true);
                                            } else {
                                                setShowCalendar(false);
                                            }
                                        }}
                                    >
                                        {item.label}
                                    </li>
                                ))}
                            </ul>
                        )}

                        {/* Calendar Dropdown */}
                        {showCalendar && (
                            <div
                                ref={calendarRef}
                                className="absolute z-30 mt-2 bg-white rounded-lg p-2 w-[350px]"
                            >
                                <DateRange
                                    editableDateInputs={true}
                                    onChange={(item) => setCustomRange([item.selection])}
                                    moveRangeOnFirstSelection={false}
                                    ranges={customRange}
                                    maxDate={new Date()}
                                    showDateDisplay={false}
                                />
                                <button
                                    onClick={handleApplyCustomDate}
                                    className="w-full mt-2 bg-[#0CBB7D] text-white text-sm py-1 px-3 rounded hover:bg-green-600"
                                >
                                    Apply
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Provider Filter */}
                    <div className="relative flex w-full" ref={providerRef}>
                        <button
                            onClick={() => setShowProviderDropdown((prev) => !prev)}
                            className="sm:w-[100px] w-full text-gray-500 h-9 px-3 py-2 border-2 rounded-lg text-left text-[12px] bg-white flex justify-between items-center font-[600]"
                            type="button"
                        >
                            <span>{provider || "Provider"}</span>
                            <ChevronDown
                                className={`w-4 h-4 transition-transform duration-200 ${showProviderDropdown ? "rotate-180" : ""}`}
                            />
                        </button>
                        {showProviderDropdown && (
                            <ul className="absolute z-40 w-full mt-10 bg-white border rounded-lg max-h-60 overflow-y-auto text-[12px] font-[600] text-gray-500">
                                {["Delhivery", "DTDC", "EcomExpress", "Amazon"].map((s) => (
                                    <li
                                        key={s || "empty"}
                                        className={`px-3 py-2 cursor-pointer hover:bg-green-100 ${provider === s ? "bg-green-100 font-[600]" : ""
                                            }`}
                                        onClick={() => {
                                            setProvider(s);
                                            setShowProviderDropdown(false);
                                        }}
                                    >
                                        {s || "Provider"}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <button
                        className="px-3 h-9 sm:w-none text-[10px] sm:text-[12px] border rounded-lg font-[600] text-white bg-[#0CBB7D] hover:bg-green-500 transition whitespace-nowrap"
                        onClick={handleClearFilters}
                        type="button"
                    >
                        Clear
                    </button>
                </div>
            </div>

            <div className="hidden md:block relative">
                <table className="w-full bg-white border border-gray-300 rounded-lg">
                    {/* Table Head */}
                    <thead>
                        <tr className="text-white bg-[#0CBB7D] border border-[#0CBB7D] text-[12px] font-[600]">
                            <th className="py-2 px-3 text-left">
                                <input
                                    type="checkbox"
                                    checked={selectedOrders.length === orders.length && orders.length > 0}
                                    onChange={handleSelectAll}
                                    className="cursor-pointer accent-[#0CBB7D] w-4"
                                />
                            </th>
                            <th className="py-2 px-3 text-left">Product Details</th>
                            <th className="py-3 px-3 text-left">Date</th>
                            <th className="py-2 px-3 text-left">Shipping Details</th>
                            <th className="py-2 px-3 text-left">Applied Weight</th>
                            <th className="py-2 px-3 text-left">Charged Weight</th>
                            <th className="py-2 px-3 text-left">Excess Weight & Charges</th>
                            <th className="py-2 px-3 text-left">Status</th>
                            <th className="py-2 px-3 text-left">Actions</th>
                        </tr>
                    </thead>

                    {/* Table Body */}
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="9" className="text-center py-4">
                                    <ThreeDotLoader />
                                </td>
                            </tr>
                        ) : orders.length === 0 ? (
                            <tr>
                                <td colSpan="9" className="text-center py-4">
                                    No pending weight discrepancies found.
                                </td>
                            </tr>
                        ) : (

                            orders.map((order, index) => {
                                const discrepancyDate = new Date(order.createdAt);
                                const today = new Date();
                                const daysPassed = Math.floor((today - discrepancyDate) / (1000 * 60 * 60 * 24));
                                const remainingDays = Math.max(7 - daysPassed, 0);

                                return (
                                    <tr key={index} className="border border-gray-300 hover:bg-gray-50 transition-all text-[12px] font-[400] text-gray-500">
                                        {/* Box for Remaining Days */}
                                        <td className="py-2 px-3 relative">
                                            <div className="absolute -top-2 left-2 bg-red-500 text-white text-[10px] px-2 py-1 w-auto rounded-lg whitespace-nowrap">
                                                {remainingDays > 0 ? `${remainingDays} days left` : "Auto Accepting Soon"}
                                            </div>

                                            <input
                                                type="checkbox"
                                                checked={selectedOrders.includes(order._id)}
                                                onChange={() => handleCheckboxChange(order._id)}
                                                className="cursor-pointer accent-[#0CBB7D] w-4"
                                            />
                                        </td>
                                        <td className="py-2 px-3 whitespace-nowrap" style={{ maxWidth: "300px", width: "250px" }}>
                                            <p>
                                                <span>Product Name:</span>{" "}
                                                <span className="inline-block truncate align-bottom" title={order.productDetails.map(item => item.name).join(", ")}>
                                                    {order.productDetails.map(item => item.name).join(", ")}
                                                </span>
                                            </p>
                                            <p>
                                                <span>SKU:</span>{" "}
                                                {order.productDetails.map(item => item.sku).join(", ")}
                                            </p>
                                            <p>
                                                <span>QTY:</span>{" "}
                                                {order.productDetails.map(item => item.quantity).join(", ")}
                                            </p>
                                        </td>
                                        <td className="py-2 px-3 whitespace-nowrap">
                                            <p>{new Date(order.createdAt).toLocaleTimeString()}</p>
                                            <p>{new Date(order.createdAt).toLocaleDateString()}</p>
                                        </td>
                                        <td className="py-2 px-3 whitespace-nowrap">
                                            <p>AWB: <span onClick={() => handleTrackingByAwb(order.awbNumber)} className="text-[#0CBB7D] font-[600] cursor-pointer">{order.awbNumber}</span></p>
                                            <p className="text-gray-500">{order.courierServiceName}</p>
                                        </td>
                                        <td className="py-2 px-3 whitespace-nowrap">
                                            <p className="font-[600]">Applied weight: {order.enteredWeight
                                                .applicableWeight} Kg</p>
                                            <p>
                                                Dead Weight: {order.enteredWeight.deadWeight} Kg
                                            </p>
                                            <div className="text-gray-500">
                                                <p>Volumetric weight:</p>
                                                <p>
                                                    {(
                                                        ((order.enteredWeight?.volumetricWeight?.length || 0) *
                                                            (order.enteredWeight?.volumetricWeight?.breadth || 0) *
                                                            (order.enteredWeight?.volumetricWeight?.height || 0)) /
                                                        5000
                                                    ).toFixed(2)}{" "}
                                                    Kg (
                                                    {order.enteredWeight?.volumetricWeight?.length || 0}cm x{" "}
                                                    {order.enteredWeight?.volumetricWeight?.breadth || 0}cm x{" "}
                                                    {order.enteredWeight?.volumetricWeight?.height || 0}cm)
                                                </p>
                                            </div>

                                        </td>
                                        <td className="py-2 px-3 whitespace-nowrap">
                                            <p className="font-[600]">
                                                Charged weight: {order.chargedWeight.applicableWeight} Kg
                                            </p>
                                            <p>
                                                Dead Weight: {order.chargedWeight.deadWeight} Kg
                                            </p>
                                            {order.chargedDimension?.length && order.chargedDimension?.breadth && order.chargedDimension?.height && (
                                                <p className="text-gray-500">
                                                    Volumetric weight:{" "}
                                                    {(
                                                        (order.chargedDimension?.length *
                                                            order.chargedDimension?.breadth *
                                                            order.chargedDimension?.height) /
                                                        5000
                                                    ).toFixed(2)}{" "}
                                                    Kg (
                                                    {order.chargedDimension?.length}cm x{" "}
                                                    {order.chargedDimension?.breadth}cm x{" "}
                                                    {order.chargedDimension?.height}cm)
                                                </p>
                                            )}

                                        </td>

                                        <td className="py-2 px-3 whitespace-nowrap">
                                            <p className="font-[600]"><span>Excess Weight:</span>
                                                {order.excessWeightCharges.excessWeight} Kg
                                            </p>
                                            <p><span>Excess Charges:</span>
                                                {order.excessWeightCharges.excessCharges
                                                }
                                            </p>
                                            <p><span>Pending Amount:</span>
                                                {order.excessWeightCharges.pendingAmount
                                                }
                                            </p>
                                        </td>
                                        <td className="py-2 px-3 whitespace-nowrap">
                                            <span className="px-2 py-1 rounded text-[10px] bg-green-100 text-green-700">
                                                {order?.status}
                                            </span>
                                        </td>

                                        <td className="py-2 px-3 whitespace-nowrap">
                                            <div className="relative" ref={(el) => { if (el) dropdownRefs.current[index] = el }}></div>
                                            <button
                                                ref={(el) => {
                                                    if (el) toggleButtonRefs.current[index] = el;
                                                }}
                                                // ✅ Imp
                                                className="px-2 py-2 flex items-center justify-center bg-[#0CBB7D] text-white rounded-full"
                                                onClick={() => toggleDropdown(index)}
                                            >
                                                <FiMoreHorizontal className="text-[12px]" />
                                            </button>

                                            {dropdownOpen === index && (
                                                <div className="absolute right-6 mt-2 w-32 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                                                    <ul className="text-[10px] font-[600]">
                                                        <li className={`px-3 py-2 text-gray-500 hover:bg-green-100 cursor-pointer ${loading ? "cursor-not-allowed" : ""}`}>
                                                            <button onClick={(e) => { handleDiscrepancy(order.awbNumber); e.stopPropagation(); setDropdownOpen(null) }} disabled={loading}>
                                                                {loading ? "Processing..." : "Accept Discrepancy"}
                                                            </button>
                                                        </li>
                                                        <li className="px-3 py-2 text-gray-500 hover:bg-green-100 cursor-pointer">
                                                            <button onClick={(e) => { handleOpenPopup(order.awbNumber); e.stopPropagation(); setDropdownOpen(null) }}>
                                                                Raise Discrepancy
                                                            </button>
                                                        </li>
                                                        {order.adminStatus === "Discrepancy Declined" && (
                                                            <li className="px-3 py-2 text-gray-500 hover:bg-green-100 cursor-pointer">
                                                                <button onClick={(e) => { handleDeclinedPopup(order.awbNumber, order.discrepancyDeclinedReason); e.stopPropagation(); setDropdownOpen(null) }}>
                                                                    Declined Reason
                                                                </button>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })

                        )}
                    </tbody>
                </table>

            </div>


            <div className="block md:hidden space-y-2">
                <div className="p-1 bg-green-100 rounded-md flex gap-3 items-center">
                    <input
                        type="checkbox"
                        checked={
                            selectedOrders.length === orders.length &&
                            orders.length > 0
                        }
                        onChange={handleSelectAll}
                        className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                    />
                    <span className="text-[10px] font-[600]">Select All</span>
                </div>

                {loading ? (
                    <div className="text-center py-4">
                        <ThreeDotLoader />
                    </div>
                ) : orders.length === 0 ? (
                    <div className="text-center py-4">
                        No pending weight discrepancies found.
                    </div>
                ) : (
                    orders.map((order, index) => {
                        const discrepancyDate = new Date(order.createdAt);
                        const today = new Date();
                        const daysPassed = Math.floor((today - discrepancyDate) / (1000 * 60 * 60 * 24));
                        const remainingDays = Math.max(7 - daysPassed, 0);

                        return (
                            <div key={index} className="bg-white rounded-lg border border-gray-300 overflow-hidden text-[11px] font-[600] relative">
                                {/* Top Header: Order ID + Checkbox + Remaining Days */}
                                <div className="flex justify-between items-start px-3 py-2 text-gray-700 font-semibold">
                                    {/* Left: Checkbox + Order ID */}
                                    <div className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            checked={selectedOrders.includes(order._id)}
                                            onChange={() => handleCheckboxChange(order._id)}
                                            className="accent-[#0CBB7D] w-3 h-3"
                                        />
                                        <span>Order ID : #{order.orderId || order._id?.slice(-6)}</span>
                                    </div>

                                    {/* Right: Remaining Days */}
                                    <span
                                        className={`text-[10px] px-2 py-1 rounded-lg shadow-sm ${remainingDays > 0 ? "bg-red-100 text-red-700" : "bg-yellow-100 text-yellow-700"
                                            }`}
                                    >
                                        {remainingDays > 0 ? `${remainingDays} days left` : "Auto Accepting Soon"}
                                    </span>

                                    <div className="relative" ref={(el) => dropdownRefs.current[index] = el}>
                                        <button
                                            className="px-3 text-gray-500 rounded-lg text-[10px]"
                                            onClick={() => toggleDropdown(index)}
                                        >
                                            <FiMoreHorizontal size={20} className="text-black" />
                                        </button>
                                        {dropdownOpen === index && (
                                            <>
                                                <div className="fixed inset-0 z-40 md:hidden" onClick={() => setDropdownOpen(null)}> </div>
                                                <div className="absolute w-36 right-0 bg-white border border-gray-200 rounded-lg z-50">
                                                    <ul className="text-[10px] font-[600]">
                                                        <li className="px-3 py-2 hover:bg-gray-100 cursor-pointer">
                                                            <button onClick={() => handleDiscrepancy(order.awbNumber)} disabled={loading}>
                                                                {loading ? "Processing..." : "Accept Discrepancy"}
                                                            </button>
                                                        </li>
                                                        <li className="px-3 py-2 hover:bg-gray-100 cursor-pointer">
                                                            <button onClick={() => handleOpenPopup(order.awbNumber)}>Raise Discrepancy</button>
                                                        </li>
                                                        {order.adminStatus === "Discrepancy Declined" && (
                                                            <li className="px-3 py-2 hover:bg-gray-100 cursor-pointer">
                                                                <button onClick={() => handleDeclinedPopup(order.awbNumber, order.discrepancyDeclinedReason)}>
                                                                    Declined Reason
                                                                </button>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Weight Discrepancy Row */}
                                <div className="flex justify-between items-center px-3 py-2 bg-red-50 text-[10px] font-[600]">
                                    <div className="text-red-600">
                                        Charged Weight: {order.chargedWeight?.applicableWeight} Kg
                                    </div>
                                    <div className="text-gray-500">
                                        Applied Weight: {order.enteredWeight?.applicableWeight} Kg
                                    </div>
                                </div>

                                {/* Discrepancy Raised Date + Auto Accept */}
                                <div className="flex items-center justify-between px-3 py-2 bg-white">
                                    <div className="text-gray-500">
                                        Discrepancy Raised On:{" "}
                                        {new Date(order.createdAt).toLocaleDateString("en-GB")}
                                    </div>
                                    <div className="bg-green-100 text-green-700 text-[10px] px-2 py-1 rounded-lg">
                                        {order.status}
                                    </div>
                                </div>

                                {/* Footer: Courier Info */}
                                <div className="flex justify-between items-center px-3 py-2 bg-green-100">
                                    <div className="flex items-center gap-2">
                                        {(() => {
                                            // Find a key that matches part of the courierServiceName
                                            const logoKey = Object.keys(carrierLogos).find((key) =>
                                                order.courierServiceName?.toLowerCase().includes(key.toLowerCase())
                                            );
                                            const logoSrc = carrierLogos[logoKey] || "/courier-placeholder.png";

                                            return (
                                                <img
                                                    src={logoSrc}
                                                    alt="courier"
                                                    className="w-6 h-6 border-2 border-gray-300 rounded-full object-contain"
                                                />
                                            );
                                        })()}
                                        <span className="font-[600] text-gray-500">
                                            {order.courierServiceName}
                                        </span>
                                    </div>
                                    <span className="font-[600] text-gray-500">
                                        AWB : <span className="text-[#0CBB7D]">{order.awbNumber}</span>
                                    </span>
                                    <span className="font-[600] text-gray-500">
                                        ₹{order.excessWeightCharges.pendingAmount}
                                    </span>
                                </div>
                            </div>
                        );


                    })
                )}
            </div>




            <AcceptAllModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onConfirm={() => {
                    console.log("Accepting all orders:", selectedOrders);
                    setIsModalOpen(false);

                }}
                price={price}
                selectedOrders={selectedOrders}
                setRefresh1={setRefresh1}
                setRefresh={setRefresh}
            />
            {isOpen && <UploadImageModal setRefresh1={setRefresh1}
                setRefresh={setRefresh} awbNumber={awbNumber} onClose={() => setIsOpen(false)} />}

            {declienedPopup && <DeclinedReasonPopup isOpen={declienedPopup} onClose={() => setDeclienedPopup(false)} awbNumber={awbNumber} declinedReason={reason} />}

            {/* Pagination Controls */}
            <div className="flex justify-between items-center mt-6 gap-4 flex-wrap text-[10px] font-[600]">
                <div className="flex items-center gap-2">
                    <label htmlFor="limit" className="text-gray-700 text-[10px] font-[600]">Show:</label>
                    <select
                        id="limit"
                        value={limit}
                        onChange={(e) => {
                            const selected = e.target.value;
                            if (selected === 'All') {
                                setLimit("All"); // null means no limit
                                setPage(1);
                            } else {
                                setLimit(parseInt(selected));
                                setPage(1); // reset to first page when changing limit
                            }
                        }}
                        className="px-3 py-2 border rounded-md text-[10px] font-[600]"
                    >
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={75}>75</option>
                        <option value={100}>100</option>
                        <option value="All">All</option>
                    </select>
                </div>

                <div className="flex items-center gap-4">
                    <button
                        onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                        disabled={page === 1}
                        className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
                    >
                        <FiArrowLeft />
                    </button>
                    <span className="text-gray-700">
                        Page {page} of {totalPages}
                    </span>
                    <button
                        onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
                        disabled={page === totalPages}
                        className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
                    >
                        <FiArrowRight />
                    </button>
                </div>
            </div>
        </div >
    );
};

export default NewDiscrepancy;